<template>
    <div>
      <p>Upload files for translation in one of the supported formats. <b-icon icon="question-square" v-b-toggle="'collapse-1'"></b-icon></p>
      <div>
          <b-collapse id="collapse-1" v-model="helpVisible" class="py-3">
              <li><code>.txt</code> Simple UTF-8 encoded text (text/plain)</li>
              <li><code>.xml</code> A UTF-8 encoded XML file (text/plain)</li>
              <li><code>.srt</code> A UTF-8 encoded SRT file.(application/subrip)</li>
              <li><code>.json</code> A json object or array. All string values within the json object or array are translated.</li>
              <li><code>.docx</code> Microsoft word document.</li>
              <li><code>.pdf</code> PDF document.</li>
          </b-collapse>
      </div>
       <b-row>
         <b-col cols="12" md="6" class="text-center">
            <v-select
                placeholder="source language"
                :options="sourceLanguages"
                class="my-2"
                v-model="sourceLanguage"
                  :reduce="language => language.code"
                >
                  <template slot="option" slot-scope="option" :value="option.code">
                    <!-- <span class="flag-icon ml-0 mr-2 small" :class="'flag-icon-' + option.flag"></span --> {{ option.label }}
                  </template>
            </v-select>
        </b-col>
        <b-col cols="12" md="6" class="text-center">
            <v-select
                placeholder="target language"
                :disabled=disabledTargetLanguage
                :options="targetLanguages(sourceLanguage)"
                class="my-2"
                v-model="targetLanguage"
                  :reduce="language => language.code"
                >
                  <template slot="option" slot-scope="option" :value="option.code">
                    <!-- <span class="flag-icon ml-0 mr-2 small" :class="'flag-icon-' + option.flag"></span --> {{ option.label }}
                    </template>
            </v-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            @vdropzone-sending="sendingEvent"
            @vdropzone-success="successEvent"
            @vdropzone-error="errorEvent"
            ></vue-dropzone>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-alert :show="alertVisible" :variant="alertType" dismissable class="mt-3">{{ alertText }}</b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button type="button"
                    variant="primary"
                    size="md"
                    class="mx-3 mt-3"
                    :disabled="disabledUploadButton"
                    @click.prevent="triggerSend()">
            TRANSLATE FILES
          </b-button>
        </b-col>
      </b-row>

<TranslateTasks></TranslateTasks>

    </div>
</template>

<script>
import dropzone from 'vue2-dropzone'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TranslateTasks from '@/views/TranslateTasks.vue'
import apiClient from '@/services/api_client_saas.js'

export default {
  name: 'app',
  components: {
    vueDropzone: dropzone,
    TranslateTasks
  },
  data: () => {
    return {
      sourceLanguage: '', //
      targetLanguage: '',
      alertType: 'warning',
      alertVisible: false,
      alertText: '',
      helpVisible: false,
      authTokenCookie: Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
    }
  },
  computed: {
    disabledTargetLanguage () {
      return this.sourceLanguage === ''
    },
    disabledUploadButton () {
      return !this.sourceLanguage || !this.targetLanguage
    },
    dropzoneOptions () {
      return {
        autoProcessQueue: false,
        acceptedFiles: '.txt,.srt,.json,.pdf,.docx,.xml',
        addRemoveLinks: true,
        url: `${process.env.VUE_APP_LANGUAGE_API_BASE_URL}/translate/upload`,
        maxFilesize: 500, // 500 MB
        headers: {
          'x-user-id': this.userId,
          'x-session-id': this.$store.state.sessionId,
          'x-auth-token': this.authTokenCookie
          // api_key: this.defaultApiKey
        },
        parallelUploads: 100,
        uploadMultiple: false,
        dictDefaultMessage: 'Upload your .docx, .pdf, .txt, .srt, .xml, or .json file(s)',
        timeout: 1800000
        // chunking: true,
        // chunkSize: 500, // Bytes
        // thumbnailWidth: 80, // px
        // thumbnailHeight: 80
      }
    },
    userId () {
      var token = Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
      var decoded = jwt_decode(token)
      return decoded.sub
    },
    ...mapGetters([
      'sourceLanguages',
      'targetLanguages',
      'defaultApiKey'
    ])
  },
  methods: {
    triggerSend () {
      this.alertVisible = false
      if (this.sourceLanguage === '') {
        this.alertText = 'Please select the source language'
        this.alertVisible = true
        return
      }
      if (this.sourceTarget === '') {
        this.alertText = 'Please select the target language'
        this.alertVisible = true
        return
      }
      // validate API key early
      apiClient.get('/translate/validate', { headers: { api_key: this.defaultApiKey } }).then((response) => {
        this.$refs.myVueDropzone.processQueue()
      }).catch((error) => {
        this.alertType = 'danger'
        this.alertText = error.response.data.error
        this.dismissCountDown = 30
        this.alertVisible = true
      })
    },
    sendingEvent (file, xhr, formData) {
      // console.log(formData)
      xhr.setRequestHeader('x-source-lang', this.sourceLanguage)
      xhr.setRequestHeader('x-target-lang', this.targetLanguage)
      xhr.setRequestHeader('api_key', this.defaultApiKey) // caveat: named this to avoid confusion with AWS APIGW x-api-key
      // xhr.setRequestHeader('x-auth-token', this.authTokenCookie)
      // formData.append('description', this.description)
    },
    successEvent (file, response) {
      this.$store.dispatch('insertTasks', response)
      console.log(response)
      this.$refs.myVueDropzone.removeFile(file)
    },
    errorEvent (file, response) {
      console.log(response)
      this.alertText = 'Error uploading : ' + response.error
      this.alertType = 'danger'
      this.alertVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
